import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';

import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import {
  CommonPaginationResponse,
  CommonResponse,
  PaginateResponse,
  processNormal, processPagination,
  VoidResponse
} from '../common/response.model';
import { ErrorHandlingService } from '../common/error-handling.service';
import { Bank } from './bank.model';
import { Observable } from 'rxjs';
import { BankForm } from '../../FormModels/bank-form.model';

@Injectable()
export class BanksService {

  constructor(private http: HttpClient, private errorHandling: ErrorHandlingService) {
  }


  // ABM de bankes

  /**
   * Obtener el listado de todos los bankes sin paginacion
   *
   * @return Observable<Bank[]>
   */
  public listAll(filter = '', allVerified = false): Observable<Bank[]> {

    let params = new HttpParams().append('no-paginate', '1');
    if (filter !== '') { params = params.append('filter', filter); }

    const url = allVerified ? '/search' : '';

    return this.http.get<CommonResponse<Bank[]>>(
      environment.apiUrl + 'banks' + url,
      {
        params
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  /**
   * Obtener el listado de todos los bankes con paginacion
   *
   * @return Observable<PaginateResponse<Bank[]>>
   */
  public listPaginated(page, per_page, filter = ''): Observable<PaginateResponse<Bank[]>> {
    let params = new HttpParams().append('paginate_per_page', per_page.toString()).append('page', page);
    if (filter !== '') { params = params.append('filter', filter); }

    return this.http.get<CommonPaginationResponse<Bank[]>>(
      environment.apiUrl + 'banks',
      {
        params
      }
    ).pipe(
      map(resp => processPagination(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  /**
   * Agregar un bank a la plataforma
   *
   * @return Observable<Bank>
   */
  public add(bank: BankForm): Observable<Bank> {

    const bodyParams = {
      name: bank.name,
    };

    return this.http.post<CommonResponse<Bank>>(
      environment.apiUrl + 'banks',
      bodyParams
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  /**
   * Ver datos de un bank
   *
   * @return Observable<Bank>
   */
  public show(id: string, verified: boolean = false): Observable<Bank> {

    let params = new HttpParams();
    if (verified) { params = params.append('public', 'true'); }

    return this.http.get<CommonResponse<Bank>>(
      environment.apiUrl + 'banks/' + id,
      {
        params
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  /**
   * Editar datos del bank
   *
   * @return Observable<Bank>
   */
  public edit(id: string, bank: BankForm): Observable<Bank> {

    const bodyParams = {
      name: bank.name
    };

    return this.http.put<CommonResponse<Bank>>(
      environment.apiUrl + 'banks/' + id,
      bodyParams
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  /**
   * Eliminar el bank
   *
   * @return Observable<VoidResponse>
   */
  public delete(id: string, type: string = 'drop'): Observable<VoidResponse> {

    return this.http.delete<CommonResponse<VoidResponse>>(
      environment.apiUrl + 'banks/' + id,
      {
        params: new HttpParams().append('type', type)
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }
}
